<template>
  <!-- 远传表历史数据 -->
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="24">
          <a-col :md="6" :sm="12">
            <a-form-item label="用户编码">
              <a-input v-model="query.userCode" placeholder="请输入用户编码" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="用户名称">
              <a-input v-model="query.userName" placeholder="请输入用户名称" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="用水性质">
              <a-select placeholder="请选择" default-value v-model="query.waterUsageType">
                <a-select-option :value="1">居民用水</a-select-option>
                <a-select-option :value="2">非居民用水</a-select-option>
                <a-select-option :value="3">特种用水</a-select-option>
                <a-select-option :value="4">工业用水</a-select-option>
                <a-select-option :value="5">混合用水</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="表册分组">
              <a-select placeholder="请选择" v-model="query.groupId" allow-clear @change="onGroupChange">
                <a-select-option v-for="item in GroupList" :key="item.id" :value="item.id">
                  {{ item.groupName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="选择表册">
              <a-select
                v-model="query.meterBookId"
                placeholder="请选择表册"
                :loading="meterBooksLoading"
                allow-clear
                show-search
                :filter-option="filterMeterBookOption"
                :disabled="!query.groupId"
              >
                <a-select-option v-for="item in filteredMeterBooksList" :key="item.id" :value="String(item.id)">
                  {{ item.bookName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="推送时间">
              <a-range-picker @change="onChange" style="width: 100%" />
            </a-form-item>
          </a-col>

          <a-col :md="8" :sm="24">
            <a-form-item label="环比增长率">
              <div class="range-input-container">
                <a-input
                  v-model="query.minGrowthRate"
                  placeholder="最小值"
                  allow-clear
                  @input="validateNumber('minGrowthRate')"
                />
                <div class="circle">~</div>
                <a-input
                  v-model="query.maxGrowthRate"
                  placeholder="最大值"
                  allow-clear
                  @input="validateNumber('maxGrowthRate')"
                />
              </div>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="16">
            <a-form-item>
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 12px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 12px" :loading="exportLoading" @click="exportHandleIdList()" v-action:export
                >导出</a-button
              >
              <a-button class="sup-btn" @click="supplementDate()" v-action:edit>补推数据</a-button>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 补推数据 -->
    <a-modal style="top: 20px" :width="500" :visible="visible" @ok="approvalDateko" @cancel="handleCancel">
      <template slot="title">
        <a-icon
          type="info-circle"
          theme="twoTone"
          twoToneColor="#ff4d4f"
          :style="{ fontSize: '18px', marginRight: '5px' }"
        />提示</template
      >
      <div class="prompt">
        <p>
          请确认是否将勾选的 <strong>{{ selectedRows.length }}</strong> 条数据推送到营收系统？
        </p>
      </div>
    </a-modal>
    <a-table
      size="middle"
      rowKey="id"
      bordered
      :scroll="{ x: 1800 }"
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :data-source="list"
      :columns="columns"
      :loading="dataListLoading"
      :pagination="pagination"
      @change="pageChange"
    >
      <template slot="growthRate" slot-scope="text">
        <span>{{ formatGrowthRate(text) }}</span>
      </template>
    </a-table>
  </a-card>
</template>

<script>
import dayjs from 'dayjs'
import mixinViewModule from '@/mixin/common'

const columns = [
  { title: '用户编码', dataIndex: 'userCode', key: 'userCode', width: 120 },
  { title: '用户名称', dataIndex: 'userName', key: 'userName', width: 120 },
  { title: '用户地址', dataIndex: 'userAddress', ellipsis: true, width: 200, key: 'userAddress' },
  { title: '水表厂商', dataIndex: 'manufacturer', key: 'manufacturer', width: 100 },
  { title: '水表编号', dataIndex: 'meterNumber', key: 'meterNumber', width: 120 },
  { title: '用水性质', dataIndex: 'waterUsageTypeName', key: 'waterUsageTypeName', width: 100 },
  { title: '上期行至', dataIndex: 'previousReading', key: 'previousReading', width: 100 },
  { title: '上期推送时间', dataIndex: 'previousPushTime', key: 'previousPushTime', width: 150 },
  { title: '本期行至', dataIndex: 'currentReading', key: 'currentReading', width: 100 },
  { title: '本期推送时间', dataIndex: 'currentPushTime', key: 'currentPushTime', width: 150 },
  { title: '上期用水量（m³）', dataIndex: 'previousConsumption', key: 'previousConsumption', width: 120 },
  { title: '本期用水量（m³）', dataIndex: 'currentConsumption', key: 'currentConsumption', width: 120 },
  {
    title: '环比增长率（%）',
    dataIndex: 'growthRate',
    key: 'growthRate',
    width: 120,
    scopedSlots: { customRender: 'growthRate' },
  },
  { title: '厂商推送时间', dataIndex: 'createTime', key: 'createTime', width: 150 },
  { title: '表册分组', dataIndex: 'groupName', key: 'groupName', width: 100 },
  { title: '所在表册', dataIndex: 'bookName', ellipsis: true, key: 'bookName', width: 150 },
]

export default {
  components: {
    dayjs,
  },
  mixins: [mixinViewModule],
  name: 'Task',
  data() {
    return {
      list: [],
      selectedRows: [],
      isMonth: false,
      dayjs,
      importLoading: false,
      visible: false,
      endOpen: false,
      disabled: false,
      fileList: [],
      queryUrl: '/meter-manager/remote_tables/page',
      addOrUpdateUrl: 'pipe-network/meter_reading_tasks',
      exportDataUrl: 'meter-manager/remote_tables/export',
      queryOneUrl: 'pipe-network/meter_reading_tasks',
      deleteUrl: 'pipe-network/meter_reading_tasks',
      queryBookDateUrl: 'pipe-network/meter_reading_books/list',
      queryStaffDateUrl: 'pipe-network/meter_reading_staffs/list',
      staffTreeData: [], // 分区数据选项
      GroupList: [], // 分组列表
      allMeterBooksList: [], // 所有表册列表
      meterBooksLoading: false, // 表册加载状态
      query: {
        waterUsageType: '',
        userCode: '',
        userName: '',
        bookGroup: '', // 废弃
        groupId: '', // 新增，分组id
        meterBookId: '', // 新增，表册id
        taskStatus: '',
        readingStatus: '',
        maxGrowthRate: '',
        minGrowthRate: '',
      },

      engineeringProjectEstab: {
        name: '',
        taskFrequency: '',
        cycleCount: '',
        startValue: '',
        endValue: '',
        taskStatus: 0,
        state: 0,
        dataType: '',
        bookId: '',
        bookGroup: '',
        staffId: '',
        endTime: '',
        startTime: '',
      },
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      columns,
      rule: {
        name: [{ required: true, message: '请输入计划名称', trigger: 'change' }],
        taskFrequency: [{ required: true, message: '请选择计划周期', trigger: 'change' }],
        cycleCount: [{ required: true, message: '请选择月份数', trigger: 'change' }],
        startValue: [{ required: true, message: '请选择计划开始时间', trigger: 'change' }],
        endValue: [{ required: true, message: '请选择计划结束时间', trigger: 'change' }],
        bookId: [{ required: true, message: '请选择表册', trigger: 'change' }],
        bookGroup: [{ required: true, message: '请选择组别', trigger: 'change' }],
        staffId: [{ required: true, message: '请选择抄表员', trigger: 'change' }],
      },
    }
  },
  computed: {
    // 根据当前选中的分组ID过滤表册列表
    filteredMeterBooksList() {
      if (!this.query.groupId) {
        return []
      }
      return this.allMeterBooksList.filter((item) => {
        // 支持多种可能的字段名
        const itemGroupId = item.groupId || item.group_id || item.meterBookGroupId || item.meter_book_group_id
        return String(itemGroupId) === String(this.query.groupId)
      })
    },
  },
  created() {
    this.getGroupList()
    this.getMeterBooksList()
  },
  methods: {
    // 根据id 修改
    addOrUpdateHandle(id) {
      // console.log(id);
      this.disabled = true
      this.isUpdate = false
      this.currentId = id
      this.RightData = []
      if (id) {
        this.isUpdate = true
        this.$http
          .get(`${this.queryOneUrl}/${this.currentId}`)
          .then(({ data }) => {
            this.engineeringProjectEstab = {
              userName: data.userName,
              taskFrequency: data.taskFrequency,
              cycleCount: data.cycleCount,
              startValue: data.startTime,
              endValue: data.endTime,
              taskStatus: data.taskStatus,
              state: data.state,
              dataType: data.dataType,
              bookId: data.bookId,
              bookGroup: data.bookGroup,
              staffId: data.staffId,
              endTime: data.endTime,
              startTime: data.startTime,
            }
            if (data.taskFrequency == '月') {
              this.isMonth = true
            } else {
              this.isMonth = false
            }
          })
          .catch(() => {})
      }
    },
    pageChange(pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.queryList()
    },
    //获取远传表历史数据列表
    queryList() {
      const params = {
        ...this.query,
      }

      // 处理查询参数，去除空值
      Object.keys(params).forEach((key) => {
        if (params[key] === '' || params[key] === null || params[key] === undefined) {
          delete params[key]
        }
      })

      // 处理数字类型参数
      if (params.minGrowthRate) {
        params.minGrowthRate = parseFloat(params.minGrowthRate)
      }
      if (params.maxGrowthRate) {
        params.maxGrowthRate = parseFloat(params.maxGrowthRate)
      }

      this.dataListLoading = true
      this.$http
        .post(this.queryUrl, params)
        .then(({ data }) => {
          this.dataListLoading = false
          if (this.needPage) {
            this.list = data.list || []
            this.selectedRows = []
            this.pagination.total = data.total ? parseInt(data.total) : 0
            if (data.total > 0) {
              this.isadd = false
            } else {
              this.isadd = true
            }
          } else {
            this.list = data
          }
        })
        .catch(() => {
          this.dataListLoading = false
        })
    },
    // 时间
    disabledStartDate(current) {
      console.log(current, 'lll')
      return current && current < dayjs().endOf('day')
      // const endValue = this.engineeringProjectEstab.endValue
      // if (!startValue || !endValue) {
      //   return false
      // }
      // return startValue.valueOf() > endValue.valueOf()
    },
    disabledEndDate(endValue) {
      console.log(this.engineeringProjectEstab.startValue, 'ppp')
      const startValue = this.engineeringProjectEstab.startValue
      if (!endValue || !startValue) {
        return false
      }
      return startValue.valueOf() >= endValue.valueOf()
    },
    handleStartOpenChange(open) {
      if (!open) {
        this.endOpen = true
      }
    },
    handleEndOpenChange(open) {
      this.endOpen = open
    },
    // 数字输入验证（支持负数）
    validateNumber(field) {
      const value = this.query[field]
      if (value && !/^-?\d*\.?\d*$/.test(value)) {
        // 如果不是数字格式（包括负数），清空输入
        this.query[field] = value.replace(/[^\d.-]/g, '')
        // 确保负号只能出现在开头
        if (this.query[field].indexOf('-') > 0) {
          this.query[field] = this.query[field].replace(/-/g, '')
        }
      }
    },
    onChangeh(date, dateString) {
      console.log(dateString)
      this.engineeringProjectEstab.startTime = dateString
      // this.engineeringProjectEstab.startValue = dateString
    },
    onChanget(date, dateString) {
      this.engineeringProjectEstab.endTime = dateString
    },
    addOrUpdateH() {
      this.disabled = false
    },
    handleCancelh() {
      this.isMonth = false
      this.endOpen = false
      this.$refs.ruleForm.resetFields()
    },
    approvalDateko() {
      this.visible = false
    },
    handleCancel() {
      this.visible = false
    },
    changeFrequency(val) {
      if (val == '月') {
        this.isMonth = true
      } else {
        this.isMonth = false
        this.engineeringProjectEstab.cycleCount = ''
      }
    },
    handleOk(e) {
      e.preventDefault()
      this.addOrUpdateForm.validateFields((err, values) => {
        if (!err) {
          var params = {
            id: this.currentId,
            ...values,
          }
          this.$http[!this.currentId ? 'post' : 'put'](this.addOrUpdateUrl, params)
            .then((res) => {
              if (res.code === 0) {
                this.addOrUpdateVisible = false
                this.queryList()
                return this.$message.success(res.message)
              }
            })
            .catch(() => {})
        }
      })
    },
    historyData() {
      this.$refs.historyModal.show()
    },
    getGroupList() {
      this.$http.get('/meter-manager/meter_book_groups/list').then(({ data }) => {
        this.GroupList = data
      })
    },
    getMeterBooksList() {
      this.meterBooksLoading = true
      this.$http
        .get('/meter-manager/meterBooks/list')
        .then(({ data }) => {
          this.allMeterBooksList = Array.isArray(data) ? data : data.list || data.data || []
          this.meterBooksLoading = false
        })
        .catch((error) => {
          console.error('获取表册列表失败:', error)
          this.meterBooksLoading = false
          this.$message.error('获取表册列表失败')
          this.allMeterBooksList = []
        })
    },
    onGroupChange(value) {
      this.query.meterBookId = '' // 清空表册选择
    },
    getGrowthRateClass(rate) {
      if (!rate) return ''
      const numRate = parseFloat(rate)
      if (numRate > 50) return 'growth-rate-high'
      if (numRate > 20) return 'growth-rate-medium'
      if (numRate < -20) return 'growth-rate-low'
      return 'growth-rate-normal'
    },
    formatGrowthRate(rate) {
      if (!rate) return '-'
      return `${parseFloat(rate).toFixed(2)}%`
    },
    getPushedCount() {
      return this.list.filter((item) => item.readingStatusName === '已推送').length
    },
    getUnpushedCount() {
      return this.list.filter((item) => item.readingStatusName === '已审核').length
    },
    onChange(date, dateString) {
      console.log(date, dateString)
    },
    changeFile(info) {},
    handleTaskProgress() {},
    handleViewTrajectory() {},
    handleViewImages() {},

    supplementDate() {
      if (this.selectedRows.length === 0) {
        this.$message.warning('请先选择要补推的数据')
        return
      }
      this.visible = true
    },
    // 选择行变化处理
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRows = selectedRowKeys
    },
    // 分页变化时清空选择
    pageChange(pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.selectedRows = []
      this.queryList()
    },
    // 清空选择
    clearSelection() {
      this.selectedRows = []
      this.$message.success('已清空选择')
    },

    // 重写重置方法，清空所有查询条件
    resetList() {
      this.query = {
        waterUsageType: '',
        userCode: '',
        userName: '',
        bookGroup: '', // 废弃
        groupId: '', // 新增，分组id
        meterBookId: '', // 新增，表册id
        taskStatus: '',
        readingStatus: '',
        maxGrowthRate: '',
        minGrowthRate: '',
      }
      this.pagination.current = 1
      this.selectedRows = []
      this.queryList()
    },

    // 表册搜索过滤函数
    filterMeterBookOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
  },
  watch: {},
}
</script>

<style lang="less" scoped>
.tenant-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
/deep/.ant-table-thead > tr > th {
  text-align: center;
  background-color: #fafafa;
}

/deep/.ant-table-tbody > tr > td {
  text-align: center;
}

/deep/.ant-table-tbody > tr:hover > td {
  background-color: #f5f5f5;
}

.growth-rate-high {
  color: #f5222d;
  font-weight: 600;
}

.growth-rate-medium {
  color: #fa8c16;
  font-weight: 600;
}

.growth-rate-low {
  color: #52c41a;
  font-weight: 600;
}

.growth-rate-normal {
  color: #1890ff;
}

.statistic-item {
  text-align: center;
}

.statistic-title {
  font-size: 12px;
  color: #666;
  margin-bottom: 4px;
}

.statistic-value {
  font-size: 24px;
  font-weight: 600;
  color: #1890ff;
}

.statistic-value.success {
  color: #52c41a;
}

.statistic-value.warning {
  color: #fa8c16;
}

.statistic-value.primary {
  color: #1890ff;
}

/deep/ .ant-modal-body {
  padding: 0 24px 24px 24px;
}

.prompt {
  margin: 30px 25px 10px 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 15px;
}

.status-tag {
  width: 80px;
  text-align: center;
  font-weight: 500;
  border-radius: 4px;
  color: white !important;
}

.sup-btn {
  margin-left: 12px;
  background-color: #ff9518;
  color: white;
}

.growth rate {
  display: flex;
}

/deep/ .ant-form-item-children {
  position: relative;
  display: flex;
}

.circle {
  border: 1px solid #d9d9d9;
  width: 60px;
  border-radius: 50%;
  margin: 0 10px 0 10px;
  text-align: center;
}

.range-input-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.range-input-container .ant-input {
  flex: 1;
  min-width: 100px;
}

.status-unpush {
  color: #1890ff;
}
.status-pushed {
  color: #52c41a;
}
</style>
